import { render, staticRenderFns } from "./healthyList.vue?vue&type=template&id=613faa52&scoped=true&"
import script from "./healthyList.vue?vue&type=script&lang=ts&"
export * from "./healthyList.vue?vue&type=script&lang=ts&"
import style0 from "./healthyList.vue?vue&type=style&index=0&id=613faa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613faa52",
  null
  
)

export default component.exports